import React from 'react'
import './LitlarMyndir.scss'

export default function LitlarMyndir(props){
  const {
    slice
  } = props
  return (
    <div className='litlarMyndir__container'>
      {slice.items.map((item, i) => (
        <div key={i} className='litlarMyndir__item'>
          <img className='litlarMyndir__mynd' src={item.mynd.url} alt={item.mynd.alt}/>
            <p className='litlarMyndir__texti'>{item.titill[0].text}</p>
            {item.lysing && item.lysing[0] && (
              <p className='litlarMyndir__desc'>{item.lysing[0].text}</p>
            )}
        </div>
      ))}
    </div>
  )
}